export const capitalize = str => {
  const firstCP = str.codePointAt(0)
  const index = firstCP > 0xFFFF ? 2 : 1

  return String.fromCodePoint(firstCP).toUpperCase() + str.slice(index)
}

export const parameterize = str =>
  str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')

export const toCamelCase = str =>
  str.replace(/[\W_]+([a-z])/ig, (_m, c) => c.toUpperCase())

export const toSnakeCase = str =>
  str.replace(/([A-Z])/g, (_m, l) => `_${l.toLowerCase()}`)

export const toKebabCase = str =>
  str.replace(/([A-Z])/g, (_m, l) => `-${l.toLowerCase()}`)

export const titleize = str =>
  str.split(/[\s_-]+/).map(w => capitalize(w)).join(' ')

export const humanize = str =>
  capitalize(str.split(/[\s_.-]+/).join(' ').trim())
